import React from "react";
import { Button } from 'primereact/button';
import { Link, useNavigate } from "react-router-dom";
import Colors from "../utils/colors";

const Footer = () => {
  //closest-side, #3f87a6, #ebf8e1, #f69d3c
  //linear-gradient( to bottom right, #d5aa6b, #f6f7f8, #f6f7f8, #f6f7f8, #f6f7f8)
  //p1 - #3a7085; p-3 #d5aa6b
return (
<>
  <div style={{
    background:"radial-gradient(circle at left -25% in hsl longer hue,  #d5aa6b,   #f6f7f8, #f6f7f8)", 
      padding:"4rem 2rem", minHeight:"12rem", }}>
        <div className="flex-center">
          <div className="col-lg-8 no-padding">
            <div className="row no-margin" style={{alignItems:"center"}}>
              <div className="col-md-6" style={{paddingRight:"2rem", paddingLeft:"0px", textAlign:"left"}}>
                <div className="section-title" style={{textAlign:"left"}}>Ready to start?</div>
                <div style={{fontSize:".95rem"}}>Request for a free demo or clarity session with a product specialist or create a free account.</div>
              </div>
              <div className="col-md-6 no-padding">
                <div className="flex-center" style={{justifyContent:'flex-end'}} >
                  <div style={{margin:"5px 8px 5px 0px", }}>
                    <Link to="mailto:sales@monytrack.com?subject=Schedule a demo for MonyTrack Business&body=Hello MonyTrack Team,%0D%0A %0D%0A..." >
                        <Button
                          style={{backgroundColor:Colors.light, color:Colors.black, fontWeight:'normal !important',  fontSize:"1.2rem", borderRadius:"10px", borderColor:Colors.gray2, padding:"1.1rem 1.4rem", }}
                          className="" >Book a free demo</Button>
                    </Link>
                  </div>
                  <div style={{margin:"5px 0px 5px 8px"}}>
                    <a target="_blank" href="https://business.monytrack.com/auth/register" style={{position:'relative', zIndex:0}}>
                        <Button autoFocus
                                style={{ backgroundColor:Colors.primary, color:Colors.light, fontWeight:'normal',  fontSize:"1.2rem", borderRadius:"10px", borderColor:Colors.primary, padding:"1.1rem 1.4rem"}}
                                className="" >Start for free</Button>
                    </a>
                  </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  <div className="footer" style={{backgroundColor:Colors.bg2, borderTopColor:Colors.primary}}>
    <div className="row no-margin">
      <div className="col-md-3">
        <h5 className="bold">MonyTrack</h5>
        <p style={{fontSize:'14px', marginTop:"15px", color:Colors.black1}}>Your go-to solution for seamless finance management for businesses and individuals.</p>
        <address style={{color:Colors.black1, fontSize:"13px", marginTop:"10px"}}>
          No. 38, Orogun road, Ojoo, Ibadan<br />
          <div style={{margin:"5px 0px"}}>
            Email: support@monytrack.com
          </div>
          Phone: (+234) 09075 855 963
        </address>
      </div>
      <div className="col-md-7">
        <div className="row no-margin">
          <div className="col-md-4">
            <h5 className="bold">Products</h5>
            <ul className="footer-list" style={{fontSize:'14px', marginTop:"15px", color:Colors.black1}}>
              <li><Link to={"/business/products/accounts"}>Accounts</Link></li>
              <li><Link to={"/business/products/accounts-360"}>Accounts 360</Link></li>
              <li><Link to={"/business/products/business-payments"}>Business Payments</Link></li>
              <li><Link to={"/business/products/global-payments"}>Global Payments</Link></li>
              <li><Link to={"/business/products/usd-cards"}>Virtual USD Cards</Link></li>
              <li><Link to={"/business/products/invoicing"}>Invoicing</Link></li>
              <li><Link to={"/business/products/vendor-management"}>Vendor Management</Link></li>
              <li><Link to={"/business/products/approval-policies"}>Approval Policies</Link></li>
            </ul>
          </div>
          <div className="col-md-5">
            <h5 className="bold">Solutions</h5>
            <ul className="footer-list" >
              <li><Link to={"/business/solutions/collections"}>Collections</Link></li>
              <li><Link to={"/business/solutions/payment-workflows"}>Approval Based Payment Workflows</Link></li>
              <li><Link to={"/business/solutions/expense-management"}>Expense Management</Link></li>
              <li><Link to={"/business/solutions/invoicing"}>Invoice Automations</Link></li>
              <li><Link to={"/business/solutions/accounts-dashboard"}>Accounts Dashboard</Link></li>
              <li><Link to={"/business/solutions/global-payments"}>Global Payments</Link></li>
            </ul>
          </div>
          <div className="col-md-3">
            <h5 className="bold">Industries</h5>
            <ul className="footer-list" >
              <li><Link to={"/business/use-cases/finance-teams"}>Finance Teams</Link></li>
              <li><Link to={"/business/use-cases/marketing"}>Marketing</Link></li>
              <li><Link to={"/business/use-cases/startups"}>Startups</Link></li>
              <li><Link to={"/business/use-cases/healthcare"}>Healthcare</Link></li>
              <li><Link to={"/business/use-cases/pharmaceuticals"}>Pharmaceuticals</Link></li>
              <li><Link to={"/business/use-cases/nonprofits"}>Nonprofits</Link></li>
              <li><Link to={"/business/use-cases/fmcgs"}>FMCGs</Link></li>
              <li><Link to={"/business/use-cases/manufacturing"}>Manufacturing</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col-md-2">
        <h5 className="bold">Follow Us</h5>
        <p style={{fontSize:'14px', marginTop:"15px", color:Colors.black1}}>Connect with us accross social media.</p>
        <ul className="footer-list">
          <li><a href="#">LinkedIn</a></li>
          <li><a href="#">Twitter</a></li>
          <li><a href="#">Facebook</a></li>
          <li><a href="#">Instagram</a></li>
        </ul>
      </div>
    </div>

    <div className="flex-center" style={{padding:"3em"}}>
        <div style={{fontSize:"13px", color:Colors.gray, marginTop:"20px", textAlign:"center"}}>
          ©{(new Date()).getFullYear()} MonyTrack Financial Technologies Ltd. All Rights Reserved.
        </div>
    </div>
  </div>
</>
  );
};

export default Footer;
